import styled from "styled-components";
import theme from "../../style/theme";
import CloseSmallLineIcon from "../icons/CloseSmallLineIcon/CloseSmallLineIcon";

interface Props {
  title: string;
  onClick: () => void;
}

export const DialogTitle: React.FC<Props> = ({ title, onClick }) => {
  return (
    <TitleContainer>
      <TitleContentContainer>{title}</TitleContentContainer>
      <CloseSmallIconContainer onClick={onClick}>
        <CloseSmallLineIcon
          width="2rem"
          height="2rem"
          fill={theme.palette.primitives.gray400}
        />
      </CloseSmallIconContainer>
    </TitleContainer>
  );
};

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 40px 40px 0;
`;

const TitleContentContainer = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: ${theme.palette.primitives.black};
`;

const CloseSmallIconContainer = styled.div`
  cursor: pointer;
`;
